import React from 'react';
import { Box, Container, Typography, Grid, Card, CardActionArea, CardContent, CardMedia, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';
import Carousel from '../../components/blog/blogCarousel';

// ---- Replace these with your hosted images if you have them
const HERO_IMAGE = 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1763995977/full-width_website_header_-_Blog-flipped_k5grtj.jpg';
const PLACEHOLDER_IMG = 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1762973890/Blog_Landing_Page_Website_Header_-_Advice_p6qaqt.jpg';

const CATEGORIES = [
  {
    key: 'Industry News',
    title: 'Industry News',
    blurb: 'The latest press releases, news, and marketing efforts driving our brand forward',
    image: 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1762978967/Blog_Landing_Page_Website_Header_-_Marketing_c2bsee.jpg',
  },
  {
    key: 'Home Tips',
    title: 'Home Tips',
    blurb: 'Practical guidance for home upkeep, moving, energy savings and more.',
    image: 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1762978932/Blog_Landing_Page_Website_Header_-_Home_Tips_oalnvw.jpg',
  },
  {
    key: 'Finance',
    title: 'Finance',
    blurb: 'Budgeting, credit health, rates and personal finance essentials.',
    image: 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1762978901/Blog_Landing_Page_Website_Header_-_Finance_lh2hgt.jpg',
  },
  {
    key: 'Mortgage',
    title: 'Mortgage',
    blurb: 'Loan programs, underwriting, closing costs and everything in between.',
    image: 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1762979006/Blog_Landing_Page_Website_Header_-_Mortgage_vvizlm.jpg',
  },
  {
    key: 'Advice',
    title: 'Advice',
    blurb: 'Expert insights and answers to common questions from our lending team.',
    image: PLACEHOLDER_IMG,
  },
];

export default function BlogLandingCategories() {
  return (
    <>
      <LandingPageNav />
<Box sx={(theme) => ({ ...theme.mixins.toolbar })} />
 {/* Hero */}
<Box
  sx={{
    position: 'relative',
    width: '100%',
    overflowX: 'hidden',
    backgroundImage: `url(${HERO_IMAGE})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center top',
    minHeight: { xs: '55vh', md: '70vh' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  }}
>
  {/* TEXT – using Box instead of Container so alignment matches Home & Purchase */}
  <Box
    sx={{
      position: 'relative',
      zIndex: 2,
      ml: { xs: 2, sm: 4, md: 6 },  // ← EXACT MATCH TO HOME & PURCHASE LEFT OFFSET
      maxWidth: 600,
    }}
  >
    <Typography variant="heroHeadline" sx={{ color: '#fff', textShadow: '0 2px 8px rgba(0,0,0,0.6)' }}>
      Blog
    </Typography>

    <Typography
      variant="heroSubheadline"
      sx={{
        color: '#fff',
        maxWidth: 600,
        textShadow: '0 2px 6px rgba(0,0,0,0.5)',
        mt: 1.5,
      }}
    >
      Discover free resources for your homebuying journey.
    </Typography>
  </Box>
</Box>



      {/* Categories */}
<Container
  maxWidth={false} // ✅ disables fixed width breakpoints (goes full width)
  sx={{
    py: { xs: 6, md: 8 },
    px: { xs: 2, sm: 4, md: 8, lg: 10 }, // ✅ custom gentle padding on sides
  }}
>
  <Grid
    container
    spacing={4}
    columns={{ xs: 4, sm: 8, md: 20, lg: 20, xl: 20 }} // 20 columns at md+
  >
    {CATEGORIES.map((cat) => (
      <Grid
        key={cat.key}
        item
        xs={4}          // 1 per row on phones
        sm={4}          // 2 per row on small screens (4/8)
        md={4}          // 5 per row on md+ (4/20)
      >
        <Card sx={{ height: '100%', borderRadius: 2, boxShadow: 3 }}>
        <CardActionArea component={RouterLink} to={`/blog/category/${encodeURIComponent(cat.key)}`}>



         <CardMedia
  component="img"
  height="260" // ✅ increased from 180
  image={cat.image}
  alt={cat.title}
  sx={{
    objectFit: 'cover', // keeps aspect ratio but fills space
    objectPosition: 'center top', // show top portion if needed
  }}
/>



            <CardContent>
              <Typography variant="h4" component="h2" sx={{ mb: 1 }}>{cat.title}</Typography>
              <Typography variant="body2" color="text.secondary">{cat.blurb}</Typography>
              <Typography variant="body2" sx={{ mt: 2, fontWeight: 700 }} color="primary">Explore →</Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
    ))}
  </Grid>
</Container>

      <Footer />
    </>
  );
}
